export const theme = {
  fonts: {
    body: "'Roboto', Arial, sans-serif",
    heading: "'Roboto', Arial, sans-serif",
  },
  colors: {
    background: '#2c2c2c',
    gold: '#ffd700',
    error: '#c0392b',
    discount: '#029923ff',
  },
  spacing: {
    s: '8px',
    m: '16px',
    l: '24px',
  },
  breakpoints: {
    sm: '480px',
    md: '640px',
    lg: '768px',
    xl: '1024px',
  },
};
